import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import {
  validAFM,
  validEmail,
  validEmailNotMandatory,
  validIban,
  validPhoneNumber,
  validWebSite
} from "utils";
import {
  directSupplierFieldNames,
  indirectSupplierFieldNames
} from 'pages/mainForms/mainFormSupplier/components/termsSupplier/formField';

// -------------------------------------------------------------------------------------------------
// Validations for supplier mainForm

export const validateSupplierCarrierUsers = ({formState, isDirectSupplier, isIndirectSupplier}) => {
  
  //Checks that userPhone, userLName, and userEmail are all unique among carrierUsers 
  const carrierUsersValid = ['userPhone', 'userLName', 'userEmail'].every(key => {
    const values = formState?.carrier?.carrierUsers?.map(user => user[key]) || [];
    return new Set(values).size === values?.length;
  });

  return {
    valid: !isDirectSupplier ? true : carrierUsersValid
  }

}

// WIP. e.g. will see if user is needed etc.
export const validateSupplier = ({ user, formState, isDirectSupplier, isIndirectSupplier }) => {
  const commonValidation = validateCommonSupplierFields(formState);
  const directSupplierValidation = isDirectSupplier ? validateDirectSupplier(formState) : null
  const indirectSupplierValidation = isIndirectSupplier ? validateIndirectSupplier(formState) : null

  const overallValid =
    commonValidation.valid &&
    (directSupplierValidation ? directSupplierValidation.valid : true) &&
    (indirectSupplierValidation ? indirectSupplierValidation.valid : true)

  const validationSummary = {
    common: commonValidation,
    directSupplier: directSupplierValidation,
    indirectSupplier: indirectSupplierValidation,
  };

  return {
    valid: overallValid,
    details: validationSummary,
  }
}

const validateCommonSupplierFields = (formState) => {
  const { carrier, kadBranches } = formState;
  const commonSupplierCarrierValidation = validateCommonSupplierCarrier(carrier)
  const commonSupplierKadBranchesValidation = validateCommonSupplierKadBranches(kadBranches)
  const objection = formState?.carrier?.objCommentBen ? true : false;
  const objectionEE = formState?.objection?.objectionCommitteeComment ? true : false;



  const valid = formState.activeTaskName === "task.name.temporary_rejected" ? commonSupplierCarrierValidation.valid && commonSupplierKadBranchesValidation.valid && objection : 
  formState.activeTaskName === "task.name.application_evaluation_by_committee" ?  commonSupplierCarrierValidation.valid && commonSupplierKadBranchesValidation.valid && objection && objectionEE : commonSupplierCarrierValidation.valid && commonSupplierKadBranchesValidation.valid;


  const validationSummary = {
    carrier: commonSupplierCarrierValidation,
    kadBranches: commonSupplierKadBranchesValidation,
    ...(formState.activeTaskName === "task.name.temporary_rejected" && { objection: formState?.carrier?.objCommentBen ? true : false }),
    ...(formState.activeTaskName === "task.name.application_evaluation_by_committee" && { objectionEE: formState?.objection?.objectionCommitteeComment ? true : false })
  } 

  return {
    valid,
    details: validationSummary
  }

}

const validateCommonSupplierCarrier = (carrier) => {
  const details = {
    // 1.1 Βασικά στοιχεία
    // 1.1 Στοιχεία επιχείρησης
    companyName: Boolean(carrier?.companyName),
    abiVat: Boolean(carrier?.abiVat),
    mainKAD: Boolean(carrier?.mainKAD),
    // additionalKAD: Boolean(carrier?.additionalKAD), // moved to validateCommonSupplierKadBranches
    companyLegalType: Boolean(carrier?.companyLegalType),

    // 1.1 Διεύθυνση έδρας επιχείρησης
    abiStreetFull: Boolean(carrier?.abiStreetFull), // abiStreet abiStreetNumber ?
    abiTk: Boolean(carrier?.abiTk),
    abiPerfecture: Boolean(carrier?.abiPerfecture),
    abiDistrict: Boolean(carrier?.abiDistrict),
    invMob: validPhoneNumber(carrier?.invMob),
    invMail: validEmail(carrier?.invMail),

    // website & email not required per spec atm
    website: !carrier.website || validWebSite(carrier?.website),
    // invMail: !carrier.invMail || validEmailNotMandatory(carrier?.invMail),

    // 1.2 Στοιχεία ταυτότητας εκπροσώπων
    // 1.2 Νόμιμος εκπρόσωπος
    legalSurname: Boolean(carrier?.legalSurname),
    legalName: Boolean(carrier?.legalName),
    legalVat: validAFM(carrier?.legalVat),
    legalPhone: validPhoneNumber(carrier?.legalPhone),
    legalEmail: validEmail(carrier?.legalEmail),
    // 1.2 Υπεύθυνος προγράμματος
    contactPerson: carrier.contactPersonFlag || (
      Boolean(carrier?.contactSurname) &&
      Boolean(carrier?.contactName) &&
      validAFM(carrier?.contactVat) &&
      validPhoneNumber(carrier?.contactPhone) &&
      validEmail(carrier?.contactEmail)
    ),
  }

  const isValid = Object.values(details).every(Boolean)

  return { valid: isValid, details }
}

const validateCommonSupplierKadBranches = (kadBranches) => {
  const additionalKadBranches = kadBranches?.getAllKadBranchesReturn?.kadFirmList?.kadFirmRecord?.filter((it) => it.firmActKind !== "1")

  const details = {
    // 1.1 Βασικά στοιχεία
    // 1.1 Στοιχεία επιχείρησης
    // IS NOT REQUIRED
    additionalKAD: true,//Boolean(additionalKadBranches?.length > 0), 
  }

  const isValid = Object.values(details).every(Boolean)

  return { valid: isValid, details }
}

const validateDirectSupplier = (formState) => {
  const { bank, carrier, documents, terms } = formState

  const carrierValid = validateDirectSupplierCarrier(carrier)
  const bankValidation = validateDirectSupplierBank(bank)
  const documentsValidation = validateDirectSupplierDocuments(documents)
  const termsValidation = validateDirectSupplierTerms(terms)

  const isValid =
    carrierValid.valid &&
    bankValidation.valid &&
    documentsValidation.valid &&
    termsValidation.valid

  const validationOverview = {
    carrier: carrierValid,
    bank: bankValidation,
    documents: documentsValidation,
    terms: termsValidation,
  }

  // console.log("Direct Supplier Validation Overview:", validationOverview)

  return { valid: isValid, details: validationOverview }
}

const validateIndirectSupplier = (formState) => {
  const { documents, terms } = formState

  //const documentsValidation = validateIndirectSupplierDocuments(documents)
  const termsValidation = validateIndirectSupplierTerms(terms)

  const overallValid =
    //documentsValidation.valid &&
    termsValidation.valid

  const validationOverview = {
    //documents: documentsValidation,
    terms: termsValidation,
  }

  // console.log("Indirect Supplier Validation Overview:", validationOverview)

  return { valid: overallValid, details: validationOverview }
}

const validateDirectSupplierCarrier = (carrier) => {
  const details = {
    // 1.3 Διαχείριση χρηστών
    // This needs revisit probably
    carrierUsers: (() => {
        const users = carrier?.carrierUsers || [];
        const hasUsers = users.length > 0;

        const allFieldsValid = users?.every(it =>
          Boolean(it.userLName) &&
          validPhoneNumber(it.userPhone) &&
          validEmail(it.userEmail)
        );

        //Checks that userPhone, userLName, and userEmail are all unique among carrierUsers 
        const allUnique = ['userPhone', 'userLName', 'userEmail'].every(key => {
          const values = users?.map(user => user[key]);
          return new Set(values).size === values?.length;
        });

        return hasUsers && allFieldsValid && allUnique;
      })(),

    // 2 Περιοχή δραστηριότητας
    activityArea: (
      !(isNil(carrier?.regionalUnitiesActivityArea) || isEmpty(carrier?.regionalUnitiesActivityArea)) ||
      !(isNil(carrier?.municipalitiesActivityArea) || isEmpty(carrier?.municipalitiesActivityArea))
    ),
    marketing: Boolean(carrier?.marketing),
  };

  const isValid = Object.values(details).every(Boolean)

  return { valid: isValid, details }
};

const validateDirectSupplierBank = (bank) => {
    // 3 Στοιχεία πιστωτικού ιδρύματος
  const details = {
    bnkBank: Boolean(bank?.bnkBank),
    beneficiaryIban: validIban(bank?.beneficiaryIban),
    confirmed: bank?.ibanValidation?.confirmAccountOutputRecord?.confirmed === "1",
    usageAllowed: bank?.ibanValidation?.confirmAccountOutputRecord?.usageAllowed === "1"
  };

  const isValid = Object.values(details).every(Boolean)

  return { valid: isValid, details }
}

const validateDirectSupplierDocuments = (documents) => {
  // 5 Documents
  const details = {
    supDespDeclar: Boolean(documents?.supDespDeclar),
    supCertGemi: Boolean(documents?.supCertGemi),
    supRegistryTaxisnet: Boolean(documents?.supRegistryTaxisnet),
    supIbanDetails: Boolean(documents?.supIbanDetails),
    // supOtherDocs: Boolean(documents?.supOtherDocs),
  };

  const isValid = Object.values(details).every(Boolean);

  return { valid: isValid, details };
};

// const validateIndirectSupplierDocuments = (documents) => {
//   // 4 Equipment
//   const details = {
//     supEquipmentDoc: Boolean(documents?.supEquipmentDoc),
//     supCertEquipmentDoc: Boolean(documents?.supCertEquipmentDoc),
//   };

//   const isValid = Object.values(details).every(Boolean)

//   return { valid: isValid, details }
// }

// 5 Terms
const validateDirectSupplierTerms = (terms) => validateTerms(terms, directSupplierFieldNames)
const validateIndirectSupplierTerms = (terms) => validateTerms(terms, indirectSupplierFieldNames)

const validateTerms = (terms, termNames) => {
  const details = termNames.reduce((acc, name) => {
    acc[name] = Boolean(terms?.[name])
    return acc
  }, {})

  const isValid = Object.values(details).every(Boolean)

  return { valid: isValid, details }
}
